import NoMicrophone from '@/icons/NoMicrophone';

import { cn } from '@/lib/utils';

interface MicrophoneIndicatorProps {
  isMicrophoneOn: boolean;
  className?: string;
}

/**
 * Only a muted microphone is worth a badge — a working one is the norm and its
 * icon just sits on top of the picture.
 */
export default function MicrophoneIndicator({ isMicrophoneOn, className }: MicrophoneIndicatorProps) {
  if (isMicrophoneOn) {
    return null;
  }

  return (
    <span className={cn('pointer-events-none absolute z-10 right-3 top-3 bg-slate-700/50 p-2 text-sm text-white rounded-xl flex items-center', className)}>
      <NoMicrophone className="w-4 h-4" />
    </span>
  );
}
